module.exports = __webpack_public_path__ + "img/TL.4615be26.svg";